<template>
  <div class="container page lottery">
    <van-nav-bar class="nav-bar" :border="false" fixed>
      <template #left>
        <van-icon name="arrow-left" size="20" color="#333" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="vote-header">
      <div class="vote-header-top">
        <div class="vote-status">
          <div class="vote-status-text">Voting in progress</div>
          <div class="vote-period">{{ lottery.next_expect }}</div>
          <div class="vote-timer">
            <van-count-down :time="time" format="mm:ss" @finish="check()" />
          </div>
        </div>
        <van-icon name="bars" class="menu-icon" @click="$router.push({ path: '/VoteRecord' })" />
      </div>
      <div class="vote-header-bottom">
        <span>Voting activity</span>
        <span class="history-link" @click="toggleHistoryPopup">
          History <van-icon name="arrow-down" />
        </span>
      </div>
    </div>
    <div class="wrapper">
      <div class="vote-options-title">
        <span class="title-bar"></span>Voting options
      </div>
      <div class="vote-options-grid">
        <div
          class="vote-option-card"
          :class="['opt-' + key, { active: choose[v.type] }]"
          v-for="(v, key) in lottery_peilv_list.slice(0, 4)"
          :key="key"
          @click.stop="choosePlay(v.type, v.name)"
        >
          <img class="vote-option-icon" :src="(voteIcons[key] || {}).img" :alt="(voteIcons[key] || {}).label" />
          <span class="vote-option-label">{{ (voteIcons[key] || {}).label }}</span>
        </div>
      </div>
      <div class="live-vote">
        <div class="live-vote-title">Watch live vote</div>
        <div class="live-vote-list">
          <div class="live-vote-track">
            <div
              class="live-vote-row"
              v-for="(msg, i) in liveVotesLoop"
              :key="i"
            >
              {{ msg }}
            </div>
          </div>
        </div>
      </div>
      <van-popup
        v-model="showDrawer"
        position="bottom"
        :overlay="false"
        get-container="body"
        class="vote-drawer-popup"
      >
        <div class="vote-drawer">
          <div class="vote-drawer-title">
            Choose {{ formData.length }} Vote {{ totalDot }} Dot
          </div>
          <div class="vote-drawer-input">
            <span class="dot-label">Dot:</span>
            <input
              class="dot-field"
              v-model="money"
              type="number"
              min="0"
            />
            <button class="rewind-btn" @click="allClear()">Rewind</button>
          </div>
          <button class="vote-btn" @click="doSub()">Vote</button>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          :pulling-text="$t('video.pull_down')"
          :loosing-text="$t('video.release')"
          :loading-text="$t('video.refreshing')"
        >
          <div class="wrapper history-wrapper">
            <div class="item history-head">
              <div class="left history-th">Period</div>
              <div class="right history-th">Open reward results</div>
            </div>
            <div
              v-if="!historyList.length"
              class="item history-empty"
            >
              <div class="left font-weight">--</div>
              <div class="right font-weight">{{ $t("video.no_more") }}</div>
            </div>
            <div class="item history-row" v-for="(v, key) in historyList" :key="v.expect || key">
              <div class="left history-period">{{ v.expect }}</div>
              <div class="right">
                <div class="result-pills">
                  <span class="result-pill" v-if="resultSizeName(v) !== '--'">{{ resultSizeName(v) }}</span>
                  <span class="result-pill" v-if="resultDoubleName(v) !== '--'">{{ resultDoubleName(v) }}</span>
                  <span class="result-pill empty" v-if="resultSizeName(v) === '--' && resultDoubleName(v) === '--'">--</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>

    </div>
    <van-popup v-model="showModel" position="right" :style="{ width: '70%',height:'100%' }">
       <div class="list">

          <div class="item" v-for="(i,index) in gameitemData" :key="index" @click="tabList(i.id,i.key)">
              <div>Games</div>
              <div style="margin: 15px 0 0 15px;">
                <div style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;">
                  <van-image
  width="60"
  height="61"
  :src="i.ico"
  style=""
/>
                </div>

<div style="font-size: 14px;">{{ i.name }}</div>
              </div>
            </div>


       </div>
      </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      showDrawer: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks:"",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: [],
      lottery_list_raw: [],
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: "--",
      size: "--",
      double: "--",
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: 11,
      keys: 5,
      gameitemData: [],
      voteIcons: [
        { img: "https://api.facai991.shop/1.gif", label: "Rose" },
        { img: "https://api.facai991.shop/2.gif", label: "Ship" },
        { img: "https://api.facai991.shop/3.gif", label: "Heart" },
        { img: "https://api.facai991.shop/4.gif", label: "Rocket" },
      ],
      liveVotes: [],
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.showDrawer = val.length > 0;
      },
      deep: true,
    },
  },
  methods: {
    generateLiveVotes() {
      const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const ordinals = ["first", "second", "third", "fourth", "fifth"];
      const rand = (n) => Math.floor(Math.random() * n);
      const pick = () => letters[rand(letters.length)];
      const list = [];
      for (let i = 0; i < 20; i++) {
        const head = pick() + pick();
        const tail = pick() + pick();
        const ord = ordinals[rand(ordinals.length)];
        list.push(
          `Congratulations to ${head}****${tail} for completing your ${ord} vote.`
        );
      }
      this.liveVotes = list;
    },
    getPlayTypeName(name) {
      const nameMap = {
        'big': '玫瑰',
        'small': '百合',
        'one': '烟花',
        'two': '气球',
        '单': '烟花',
        '双': '气球',
        '大': '玫瑰',
        '小': '百合'
      };
      return nameMap[name] || name;
    },
    getPlayTypeNameByIndex(index) {
      const typeNames = ['玫瑰', '百合', '烟花', '气球'];
      return typeNames[index] || '';
    },
    getPlayTypeIcon(index) {
      const iconMap = {
        0: '/img/1.png',  // 玫瑰
        1: '/img/2.png',  // 百合
        2: '/img/3.png',  // 烟花
        3: '/img/qq.png'  // 气球
      };
      return iconMap[index] || '';
    },
    back() {
      return window.history.back();
    },
    goToRecord() {
      // 跳转到投注记录页面
      this.$router.push({ path: '/GameRecord' });
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect,
            },
            url: "game_place_order",
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(this.$t("reservation.vote_success"));
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage
          ? (this.jiesuanpage = false)
          : (this.jiesuanpage = true);
      }
    },
    clearChooes(type) {

      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      console.log(type, name);
      console.log(this.choose);
      
      // 找到对应的索引
      const index = this.lottery_peilv_list.slice(0, 4).findIndex(v => v.type === type);
      
      // 如果已经选中，则取消选择
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
            break;
          }
        }
      } else {
        // 如果未选中，则选中
        this.choose[type] = true;
        this.formData.push({ name: name, type: type, index: index });
      }
      
      // 更新选号显示
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          const displayName = this.getPlayTypeNameByIndex(this.formData[j]["index"]);
          if (j === 0) {
            this.shopchoose = displayName;
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + displayName;
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
        if (this.formData.length === 1) {
          this.shopping = true;
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else if (!this.lottery || !this.lottery.id) {
        // 数据尚未加载完成（倒计时初始值为 0 会触发 finish），避免用默认 key 提前请求导致报错
        return;
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo().then(() => {
              this.getLotteryList();
            });
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryInfo().then(() => {
          this.getLotteryList();
        });
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id:this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          console.log("lottery_peilv_list:",this.lottery_peilv_list);

        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    parseOpencode(opencode) {
      if (!opencode) {
        return null;
      }
      let nums = [];
      if (Array.isArray(opencode)) {
        nums = opencode.map((n) => Number(n));
      } else if (typeof opencode === "string") {
        nums = opencode.split(",").map((n) => Number(n.trim()));
      }
      if (nums.length < 3 || nums.some((n) => Number.isNaN(n))) {
        return null;
      }
      return [nums[0], nums[1], nums[2]];
    },
    applyOpencodeResult(opencode) {
      const codes = this.parseOpencode(opencode);
      if (!codes) {
        this.sum = "--";
        this.size = "--";
        this.double = "--";
        return;
      }
      this.sum = codes[0] + codes[1] + codes[2];
      if (this.sum >= 11 && this.sum <= 18) {
        this.size = this.$t("lottery.rose");
      } else if (this.sum >= 3 && this.sum <= 10) {
        this.size = this.$t("lottery.lily");
      } else {
        this.size = "--";
      }
      if (this.sum % 2 === 0) {
        this.double = this.$t("lottery.balloon");
      } else {
        this.double = this.$t("lottery.fireworks");
      }
    },
    opencodeBall(item, index) {
      const codes = this.parseOpencode(item && item.opencode);
      return codes ? codes[index] : "--";
    },
    opencodeSum(item) {
      const codes = this.parseOpencode(item && item.opencode);
      return codes ? codes[0] + codes[1] + codes[2] : "--";
    },
    opencodeSizeLabel(item) {
      const codes = this.parseOpencode(item && item.opencode);
      if (!codes) {
        return "--";
      }
      const total = codes[0] + codes[1] + codes[2];
      if (total >= 11 && total <= 18) {
        return this.rose;
      }
      if (total >= 3 && total <= 10) {
        return this.lily;
      }
      return "--";
    },
    opencodeDoubleLabel(item) {
      const codes = this.parseOpencode(item && item.opencode);
      if (!codes) {
        return "--";
      }
      const total = codes[0] + codes[1] + codes[2];
      return total % 2 === 0 ? this.balloon : this.fireworks;
    },
    resultSizeName(item) {
      const codes = this.parseOpencode(item && item.opencode);
      if (!codes) {
        return "--";
      }
      const total = codes[0] + codes[1] + codes[2];
      if (total >= 11 && total <= 18) {
        return "Rose";
      }
      if (total >= 3 && total <= 10) {
        return "Ship";
      }
      return "--";
    },
    resultDoubleName(item) {
      const codes = this.parseOpencode(item && item.opencode);
      if (!codes) {
        return "--";
      }
      const total = codes[0] + codes[1] + codes[2];
      return total % 2 === 0 ? "Rocket" : "Heart";
    },
    getLotteryRule() {
      if (this.lottery && this.lottery.rule != null && this.lottery.rule !== "") {
        return this.lottery.rule;
      }
      const item = (this.gameitemData || []).find(
        (g) => String(g.key) === String(this.keys)
      );
      return item && item.rule != null ? item.rule : null;
    },
    getExpectPrefix(lottery = this.lottery) {
      const next = String(
        (lottery && lottery.next_expect) || ""
      );
      if (next.length <= 3) {
        return "";
      }
      return next.substring(0, next.length - 3);
    },
    getValidHistoryRows(list) {
      return (list || []).filter(
        (item) => this.parseOpencode(item && item.opencode) !== null
      );
    },
    filterLotteryListByToday(list, lottery = this.lottery) {
      const raw = this.getValidHistoryRows(list);
      const next = String((lottery && lottery.next_expect) || "");
      if (!next) {
        return raw.slice(0, 30);
      }
      const prefix = this.getExpectPrefix(lottery);
      const datePrefix = next.substring(0, 8);
      const beforeNext = raw.filter((item) => {
        const expect = String(item.expect || "");
        return expect && expect < next;
      });
      if (!beforeNext.length) {
        return [];
      }
      let preferred = beforeNext.filter((item) => {
        const expect = String(item.expect || "");
        return expect.startsWith(prefix) || expect.startsWith(datePrefix);
      });
      const result = preferred.length ? preferred : beforeNext;
      return result
        .sort((a, b) => parseInt(b.expect, 10) - parseInt(a.expect, 10))
        .slice(0, 30);
    },
    applyLatestDrawResult() {
      if (this.parseOpencode(this.lottery && this.lottery.opencode)) {
        this.applyOpencodeResult(this.lottery.opencode);
        return;
      }
      this.syncResultFromList();
    },
    toggleHistoryPopup() {
      const willOpen = !this.active;
      this.active = willOpen;
      if (willOpen) {
        this.refreshHistoryList();
      }
    },
    refreshHistoryList() {
      return this.getLotteryInfo().then(() => this.getLotteryList());
    },
    syncResultFromList() {
      const list = this.historyList;
      if (!list.length) {
        return;
      }
      const latest = list[0];
      this.applyOpencodeResult(latest.opencode);
      if (this.lottery && latest.expect) {
        this.$set(this.lottery, "draw_expect", latest.expect);
      }
    },
    initRouteParams() {
      const { key, id } = this.$route.query;
      if (key !== undefined && key !== "") {
        this.keys = key;
      }
      if (id !== undefined && id !== "") {
        this.ids = id;
      }
    },
    initDefaultLottery() {
      if (this.$route.query.key || !this.gameitemData.length) {
        return;
      }
      const first = this.gameitemData[0];
      this.keys = first.key;
      this.ids = first.id;
    },
    loadLotteryPageData() {
      this.initRouteParams();
      this.getUserInfo();
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        if (res.code === 200) {
          this.gameitemData = res.data || [];
          this.initDefaultLottery();
        }
        this.getLotteryInfo().then(() => {
          this.getLotteryList();
        });
      });
    },
    getLotteryList() {
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list_raw = res.data || [];
          this.lottery_list = this.lottery_list_raw;
          this.applyLatestDrawResult();
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res=>{
        this.gameitemData = res.data;
        console.log(this.gameitemData,'gameitemData')
      })
    },
    tabList(id,key) {
      this.ids = id
      this.keys = key
      this.showModel = false
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo().then(() => {
        this.getLotteryList();
      });
    },
    getLotteryInfo() {
      return this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        if (res.code === 200) {
          if (
            this.userInfo.money != null &&
            parseFloat(this.userInfo.money) < parseFloat(res.data.condition)
          ) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data;
          this.time = (res.data.second || 0) * 1000;

          if (this.time / 1000 === 59 && this.$route.name === "Lottery") {
            this.$toast({
              message:
                "The issue number has been updated to " +
                this.lottery.now_expect,
              className: "lottery-draw-toast",
            });
          }

          const codes = this.parseOpencode(res.data.opencode);
          if (codes) {
            this.lottery.opencode = codes;
          }
          this.applyLatestDrawResult();
        } else if (res.code === 401) {
          this.$toast(res.msg);
          return false;
        }
      }).catch(() => {
        this.applyOpencodeResult(null);
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.loadLotteryPageData();
    }
    this.generateLiveVotes();
    // 使用i18n动态获取翻译文本
    this.rose = this.$t('lottery.rose') + '🌹';
    this.lily = this.$t('lottery.lily') + '⚜️';
    this.balloon = this.$t('lottery.balloon') + '🎈';
    this.fireworks = this.$t('lottery.fireworks') + '🎆';

  },
  computed: {
    totalDot() {
      const per = parseFloat(this.money);
      if (Number.isNaN(per)) {
        return 0;
      }
      return this.formData.length * per;
    },
    liveVotesLoop() {
      return this.liveVotes.concat(this.liveVotes);
    },
    historyList() {
      const rows = this.getValidHistoryRows(this.lottery_list_raw);
      return rows
        .slice()
        .sort((a, b) => parseInt(b.expect, 10) - parseInt(a.expect, 10))
        .slice(0, 30);
    },
    resultExpect() {
      if (this.lottery.draw_expect) {
        return this.lottery.draw_expect;
      }
      const list = this.historyList;
      if (list.length && list[0].expect) {
        return list[0].expect;
      }
      return this.lottery.now_expect || "";
    },
    convertedShopchoose() {
      if (!this.shopchoose || this.shopchoose === this.$t("reservation.no_choose")) {
        return this.$t("reservation.no_choose");
      }
      
      // 如果已经是中文名称（玫瑰、百合、烟花、气球），直接返回
      const chineseNames = ['玫瑰', '百合', '烟花', '气球'];
      const parts = this.shopchoose.split(',');
      const allChinese = parts.every(part => chineseNames.includes(part.trim()));
      
      if (allChinese) {
        return this.shopchoose;
      }
      
      // 否则尝试映射
      const mapping = {
        big: '玫瑰',
        small: '百合',
        one: '烟花',
        two: '气球',
        '大': '玫瑰',
        '小': '百合',
        '单': '烟花',
        '双': '气球'
      };

      return this.shopchoose.split(',').map(keyword => {
        const trimmed = keyword.trim();
        return mapping[trimmed] || this.getPlayTypeName(trimmed) || trimmed;
      }).join(',');
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;

  line-height: 60px;
}
.record-icon {
  width: 50px;
  height: 50px;
  cursor: pointer;
  vertical-align: middle;
}
.lottery {
  background: url("/img/lotterybg.png") no-repeat
    top;
  background-size: contain;
}
.lottery .van-nav-bar {
  background: linear-gradient(
    90deg,
    rgba(223, 53, 173, 0.8),
    rgba(79, 29, 181, 0.8)
  ) !important;
}
.record {
  padding-left: 20px;
  padding-right: 20px;
  background: linear-gradient(
    90deg,
    rgba(223, 53, 173, 0.8),
    rgba(79, 29, 181, 0.8)
  );
  box-shadow: 0 4px 4px 0 #cacaca;
  z-index: 1;
}
.record .period {
  display: flex;
  align-items: center;
  padding: 20px 0;
  padding-left: 60px;
}
.record .period .cover {
  width: 104px;
  height: 104px;
  -o-object-fit: cover;
  object-fit: cover;
}
.record .period .period-number {
  flex: 1;
  margin-left: 40px;
  margin-right: 20px;
  height: 50px;
  line-height: 50px;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  text-align: center;
}
.van-count-down {
  color: #f4d70a;
  font-size: 45px;
  margin-top: 10px;
  float: right;
}
.linear-gradient {
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));

}
.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}
.kuaisan-ball .left {
  justify-content: flex-start;
}
.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle {
  width: 15%;
  font-size: 35px;
}
.van-icon {
  font-size: 40px;
}
.down {
  transition: all 0.5s;
}
.up {
  transform: rotate(180deg);
  transition: all 0.5s;
}
.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.options-bar {
  display: flex;
  align-items: center;
  height: calc(100% - 80px);
  background-color: #fff;
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}
.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}
.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}
.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}
.linear-gradient {
  width: 100%;
  height: 2px;
  pointer-events: none;
}
.sumValueTwoSides {
  display: flex;
  padding: 30px 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.rectangle {
  overflow: hidden;
}
.rectangle.large {
  width: calc(50% - 7vw) !important;
    height: 21vw !important;
    line-height: 21vw;
    text-align: center;
    background: transparent;
    margin: 0 0 4vw 4%;
    width: 20%;
    border-radius: 25px;
    overflow: visible;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    position: relative;
}
.rectangle .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0;
  background: transparent;
  pointer-events: none;
}
.rectangle .wrapper .content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  user-select: none;
  pointer-events: none;
}
.rectangle.large .wrapper {
  padding-bottom: 0;
}
.rectangle .wrapper .content.btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #e3edf7;
  padding: 1.4em;
  border-radius: 25px;
  box-shadow: 6px 6px 10px -1px rgba(0,0,0,0.15),
          -6px -6px 10px -1px rgba(255,255,255,0.7);
  border: 1px solid rgba(0,0,0,0);
  transition: transform 0.5s, box-shadow 0.5s, border 0.5s;
  gap: 15px;
}
.rectangle .wrapper .content.btn:hover {
  box-shadow: inset 4px 4px 6px -1px rgba(0,0,0,0.2),
        inset -4px -4px 6px -1px rgba(255,255,255,0.7),
        -0.5px -0.5px 0px rgba(255,255,255,1),
        0.5px 0.5px 0px rgba(0,0,0,0.15),
        0px 12px 10px -10px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.1);
  transform: translateY(0.5em);
}
.rectangle .wrapper .content.btn .type-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  flex-shrink: 0;
  transition: transform 0.5s;
  order: -1;
}
.rectangle .wrapper .content.btn:hover .type-icon {
  transform: scale(0.9);
}
.rectangle .wrapper .content.btn .btn-text {
  font-family: 'Source Han Sans CN', 'Source Han Sans', 'Noto Sans CJK SC', '思源黑体', 'Microsoft YaHei', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #333;
  margin: 0;
  line-height: 1.2;
}
.rectangle .wrapper .content .name-text {
  color: #7d7c7c;

}
.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
}
.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(110px + env(safe-area-inset-bottom, 0px));
  height: 100px;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 #cacaca;
  z-index: 2;
}
.bottom-bar .bar .left,
.bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  font-size: 20px;
}
.bottom-bar .bar .left .item .text {
  font-size: 22px;
  color: #7d7c7c;
}
.jixuanico {
  font-size: 45px;
}
.bottom-bar .bar .left .line {
  width: 2px;
  height: 50px;
  background: #dadada;
}
.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.bottom-bar .bar .mid .text {
  font-size: 30px;
  font-weight: 500;
  color: #000;
}
.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff253f;
}
.bottom-bar .bar .right {
  padding: 0 30px;
  margin: 0 30px;
  color: #fff;
  background: linear-gradient(20deg, #8673e5, #d958a4);
  font-size: 28px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 16px;
}
.rectangle.active .wrapper {
  background-color: #ff253f !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
::v-deep .van-popup {
  position: absolute;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
::v-deep .van-popup--top {
  top: -1px;
}
.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.wrapper .item .left {
  width: 30%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: #000;
}
.font-weight {
  font-weight: 700 !important;
}
.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: #000;
}
.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}
.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
}
.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.wrapper .item .kuaisan-ball .res-des {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
    width: 7vw;
    border-radius: 50%;
}
.middle{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    margin-right: 30px;
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}
.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}
.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: 60px;
}
.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}
.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}
.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}
.rectangle.active .wrapper .content.btn {
  background: #d07ac7 !important;
  box-shadow: inset 4px 4px 6px -1px rgba(0,0,0,0.2),
        inset -4px -4px 6px -1px rgba(255,255,255,0.3),
        6px 6px 10px -1px rgba(0,0,0,0.15),
        -6px -6px 10px -1px rgba(255,255,255,0.7);
}
.rectangle.active .wrapper .content.btn .btn-text {
  color: #fff !important;
}
.bottom-bar .wrapper {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 180px;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 10px 0 #cacaca;
  transition: transform 0.3s cubic-bezier(0.21, 1.02, 0.55, 1.01);
}
.bottom-bar .wrapper.active {
  transform: translateY(-100%);
}
.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}
.bottom-bar .wrapper .item .label {
  font-size: 30px;
  line-height: 30px;
  color: #000;
}
.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 16px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ed37ae;
  font-size: 30px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}
.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.van-cell {
  font-size: 30px;
  line-height: 50px;
}
.bottom-bar .wrapper .item .part {
  margin-right: 20px;
}
.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: #000;
}
.bottom-bar .wrapper .item .part .number {
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}
::v-deep .van-field__control {
  color: #ff253f;
}
.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}
.confirm-order-modal .head {
  position: relative;
  height: 80px;
}
.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}
.van-popup--center {
  border-radius: 30px;
}
.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}
.confirm-order-modal .list .lise-item {
  color: #ff253f;
}
.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}
.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(20deg, #8673e5, #d958a4);
  color: #fff;
  border: 0;
}
.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #000;
  float: right;
}
.numberBox .resBox{
  display: flex;
    align-items: center;
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    height: 100%;
    margin-left: 10px;
    width: calc(100% - 37vw);
    box-sizing: border-box;
}
.resBox .resItem{
  width: 9vw;
    height: 9vw;
    line-height: 9vw;
    margin-right: 20px;
    background: linear-gradient(90deg, #8b73e6, #d75db4);
    border-radius: 50%;
    color: #fff;
    text-align: center
}
.ressquareBox{
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
}
.ballBox{
  color: #d75db4;
    font-weight: 700;
    margin-right: 8px;
    font-size: 5vw;
}
.list{
 padding: 4vw;
}
.list .item{
  background-color: #e4e4e7;
  border-radius: 16px;
  padding: 40px;
  margin-bottom: 20px;
}

/* ===== 投票样式（按截图） ===== */
.vote-page,
.lottery {
  background: #fff;
  min-height: 100vh;
}
.nav-bar.van-nav-bar {
  background: transparent !important;
}
.nav-bar.van-nav-bar::after {
  display: none !important;
}
.nav-bar :deep(.van-nav-bar__title) {
  display: none;
}
.vote-header {
  margin: 116px 20px 0;
  padding: 28px 28px 24px;
  border-radius: 28px;
  background: linear-gradient(135deg, #f0607f, #f8a6b8);
  color: #fff;
  box-shadow: 0 10px 24px rgba(240, 96, 127, 0.25);
}
.vote-header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.vote-status-text {
  font-size: 28px;
  font-weight: 600;
}
.vote-period {
  font-size: 30px;
  font-weight: 700;
  margin-top: 6px;
}
.menu-icon {
  font-size: 40px;
  color: #fff;
}
.vote-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.vote-timer {
  margin-top: 12px;
  text-align: left;
}
.vote-timer :deep(.van-count-down) {
  display: inline-block;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  padding: 6px 16px;
  color: #fff;
  font-size: 26px;
  font-weight: 600;
}
.vote-header-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;
  font-size: 26px;
}
.history-link {
  display: flex;
  align-items: center;
  gap: 6px;
}
.vote-options-title {
  display: flex;
  align-items: center;
  margin: 30px 20px 16px;
  font-size: 30px;
  font-weight: 700;
  color: #333;
}
.vote-options-title .title-bar {
  display: inline-block;
  width: 8px;
  height: 30px;
  border-radius: 4px;
  background: #f0607f;
  margin-right: 12px;
}
.vote-options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin: 0 20px;
}
.vote-option-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  background: #fff;
  border: 2px solid #f3f3f5;
  border-radius: 18px;
  padding: 40px 20px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}
.vote-option-card.active .vote-option-label {
  color: #fff;
}
.vote-option-card.opt-0.active {
  border-color: #7c4dff;
  background: #7c4dff;
}
.vote-option-card.opt-1.active {
  border-color: #f0607f;
  background: #f0607f;
}
.vote-option-card.opt-2.active {
  border-color: #ff7043;
  background: #ff7043;
}
.vote-option-card.opt-3.active {
  border-color: #29b6f6;
  background: #29b6f6;
}
.vote-option-icon {
  width: 64px;
  height: 64px;
  object-fit: contain;
  display: block;
}
.vote-option-label {
  font-size: 32px;
  font-weight: 700;
  color: #222;
}
.live-vote {
  margin: 30px 20px 320px;
}

/* 历史开奖弹层 */
.history-wrapper {
  padding: 10px 20px 30px;
  background: #fff;
}
.history-wrapper .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #f2f2f2;
}
.history-head {
  border-bottom: 1px solid #ececec !important;
}
.history-th {
  font-size: 28px;
  font-weight: 700;
  color: #333;
}
.history-period {
  font-size: 26px;
  color: #333;
}
.history-wrapper .right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.result-pills {
  display: flex;
  gap: 12px;
  align-items: center;
}
.result-pill {
  min-width: 72px;
  text-align: center;
  padding: 8px 18px;
  border-radius: 80px;
  background: #f29bb4;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
}
.result-pill.empty {
  background: #e4e4e7;
  color: #999;
}

/* 底部投票抽屉 */
.vote-drawer-popup {
  z-index: 3000 !important;
  border-radius: 28px 28px 0 0;
  overflow: visible;
  background: transparent;
}
.vote-drawer {
  box-sizing: border-box;
  min-height: 420px;
  background: #fff;
  border-radius: 28px 28px 0 0;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.12);
  padding-top: 110px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: calc(30px + env(safe-area-inset-bottom));
}
.vote-drawer-title {
  color: #f0607f;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 22px;
}
.vote-drawer-input {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.dot-label {
  color: #f0607f;
  font-size: 28px;
  font-weight: 600;
}
.dot-field {
  flex: 1;
  height: 64px;
  border: 0;
  border-radius: 80px;
  background: #ececed;
  padding: 0 24px;
  font-size: 28px;
  color: #f0607f;
  outline: none;
}
.rewind-btn {
  height: 64px;
  padding: 0 28px;
  border: 0;
  border-radius: 80px;
  background: #e4e4e7;
  color: #8a8a8e;
  font-size: 26px;
}
.vote-btn {
  width: 100%;
  height: 80px;
  border: 0;
  border-radius: 80px;
  background: #f29bb4;
  color: #fff;
  font-size: 30px;
  font-weight: 600;
}
.vote-btn:active {
  opacity: 0.9;
}
.live-vote-title {
  background: linear-gradient(90deg, #f29bb4, #f3b3c6);
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  padding: 14px;
  border-radius: 14px 14px 0 0;
}
.live-vote-list {
  height: 200px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  border-top: 0;
  border-radius: 0 0 14px 14px;
}
.live-vote-track {
  animation: liveScroll 20s linear infinite;
}
.live-vote-row {
  font-size: 22px;
  color: #555;
  text-align: center;
  padding: 14px 10px;
  border-bottom: 1px solid #f3f3f3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@keyframes liveScroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
</style>

<style>
.lottery-draw-toast {
  font-size: 12px !important;
  line-height: 1.4 !important;
  padding: 8px 12px !important;
  max-width: 70% !important;
}
</style>
